// extracted by mini-css-extract-plugin
export default {"cursor_pointer":"AddToPlaylist_cursor_pointer__qGXAz","add_new":"AddToPlaylist_add_new__1hpGb"};